<template>
  <div class="datepicker-dropdown">
    <button
      class="face"
      :disabled="disabled"
      @click="popPopover"
    >
      <p4a-icon
        slot="face"
        class="dropdown-face"
        :icon="'date'"
        :color="disabled ? '#dddddd' : '#212121'"
      >
      </p4a-icon>
    </button>

    <p4a-popover
      v-show="dropdownActive"
      v-if="eventObject !== null"
      :is-arrow-needed="true"
      :event-object="eventObject"
      :width="275"
      :height="380"
      :align="'middle'"
      @close="dropdownActive = false"
    >
      <datepicker
        class="datepicker"
        :date="date"
        @emitValue="emitValue"
      />
    </p4a-popover>
  </div>
</template>

<script>
  import Datepicker from '../ui-kit/Datepicker'

  export default {
    name: 'DatepickerDropdown',
    components: {
      'datepicker': Datepicker
    },
    data () {
      return {
        eventObject: null,
        dropdownActive: false
      }
    },
    props: {
      date: {
        default: function () {
          return {}
        },
        type: Object
      },
      disabled: {
        default: false,
        type: Boolean
      }
    },
    methods: {
      emitValue (dateValue) {
        let self = this
        self.dropdownActive = false
        self.$emit('emitValue', dateValue)
      },
      popPopover (event) {
        let self = this

        if (!self.disabled) {
          self.dropdownActive = !self.dropdownActive
          self.eventObject = (self.dropdownActive) ? event : null
        }
      }
    },
    watch: {
      date: {
        handler: function () {
        },
        immediate: true,
        deep: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  /*@import "~ui.kit.styling";*/
  @import '../uikit';

  .datepicker-dropdown {
    height: 25px;

    .face {
      box-sizing: border-box;
      display: block;
      width: 25px;
      height: 25px;
      padding: 0;
      background-color: white;

      &:hover {
        background-color: $lightGreyBackground;
      }
      &:disabled {
        background-color: white;
        cursor: default;
      }

      .dropdown-face {
        box-sizing: border-box;
        display: block;
        width: 25px;
        height: 25px;
        padding: 3px;
        border-radius: 2px;
        border: 1px solid #dddddd;
        transition-duration: 0.2s;
      }
    }

    .dropdown-content {
      width: 275px;
      margin-top: 15px;
      margin-left: -123.5px;

      .content-point {
        position: relative;
        background-color: white;
        transform: rotate(45deg);
        content: '';
        top: -8px;
        left: calc(50% - 10px);
        height: 20px;
        width: 20px;
        border-radius: 2px;
        margin-bottom: -20px;
        -webkit-box-shadow: -3px -3px 5px 0 rgba(0,0,0,0.15);
        -moz-box-shadow: -3px -3px 5px 0 rgba(0,0,0,0.15);
        -ms-box-shadow: -3px -3px 5px 0 rgba(0,0,0,0.15);
        box-shadow: -3px -3px 5px 0 rgba(0,0,0,0.15);
      }

      .datepicker {
        width: 275px;
        -webkit-box-shadow: 0 0 5px 3px rgba(0,0,0,0.15);
        -moz-box-shadow: 0 0 5px 3px rgba(0,0,0,0.15);
        -ms-box-shadow: 0 0 5px 3px rgba(0,0,0,0.15);
        box-shadow: 0 0 5px 3px rgba(0,0,0,0.15);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/sns-components/kit-components/datepicker/DatepickerDropdown.vue